import { Grid } from "@mui/material";
import React from "react";
import "../assets/styles/myExpert.css";
import Counter from "./Counter";
import SkilsAndExperienceRoute from "./SkilsAndExperienceRoute";
import downloadIcon from "../assets/image/downloadResumeIcon.png";
import Resume from "../assets/resume/MUHAMMAD JUNAIDResume.pdf";
import tech from "../assets/image/technology (2).gif";
const MyExpert = () => {
  return (
    <div id="skils" className="my_expert_container">
      <div className="my_expert_content">
        <Grid container>
          {/* <Grid item xs={12} md={4}></Grid> */}

          <Grid item xs={12} md={6}>
            <div className="my_expert_img_logo">
              <img src={tech} alt="" />
            </div>
          </Grid>

          <Grid item xs={12} md={5}>
            <div className="my_expert_info">
              <div className="my_expert_info_title">
                <p>My expert areas</p>
              </div>
              <div className="my_expert_info_details">
                <p>
                  You can express yourself however you want and whenever you
                  want, for free. You can customize a template or make your own
                  from scratch, with an immersive library at your disposal. You
                  can express yourself however you want and whenever you free.
                  <span style={{ display: "block", marginTop: "7px" }}>
                    You can customize a template or make your own from scratch,
                    with an immersive library at your disposal.
                  </span>
                </p>
              </div>
              <div
                style={{ marginTop: "40px" }}
                className="expert_download_resume"
              >
                <a href={Resume} download>
                  Download Resume
                  <img src={downloadIcon} alt="downloadIcon" />
                </a>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} md={1}></Grid>

          <Grid item xs={12} md={1}></Grid>

          <Grid item xs={12} md={12}>
            <SkilsAndExperienceRoute />
          </Grid>
        </Grid>
        <Counter />
      </div>
    </div>
  );
};

export default MyExpert;
